import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { STATUSES } from "../../../../enums/AppointmentStatus";
import useConfirm from "../../../../hooks/useConfirm";
import PendingConfirmationTemplate from "../../../admin/pendingAppointments/components/PendingConfirmationTemplate";
import usePendingStatus from "../../../admin/pendingAppointments/hooks/usePendingStatus";

/**
 * Accepts or rejects a pending appointment once the user confirms the
 * message sent to the owner. Render the returned `ConfirmationDialog`.
 */
export default function useAppointmentStatusChange(appointment) {
  const { t } = useTranslation();
  const pendingStatus = usePendingStatus(appointment?.id);
  const { ConfirmationDialog, confirm, getMessage } = useConfirm(
    t("AreYouSure"),
    t("Accept"),
    t("Cancel"),
    "warning",
  );
  const methods = useForm({
    defaultValues: {
      statusMessage:
        t("Dear") +
        " " +
        appointment?.user?.fullName +
        ", " +
        t("RejectDefaultMessage"),
    },
  });

  async function changeStatus(status) {
    getMessage(
      <FormProvider {...methods}>
        <PendingConfirmationTemplate status={status} />
      </FormProvider>,
    );
    if (!(await confirm())) {
      return;
    }
    const message = methods.getValues("statusMessage");
    if (status === STATUSES.ACTIVE) {
      pendingStatus.acceptFn(message);
    } else {
      pendingStatus.rejectFn(message);
    }
  }

  return { changeStatus, ConfirmationDialog };
}
